// src/features/employee/EmployeeProfile.js
import React from "react";
import AddEmployee from "./AddEmployee";

const EmployeeProfile = ({ employeeId }) => {
  return <AddEmployee />;
};

export default EmployeeProfile;
